import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useGetCardsQuery } from '../../features/cards/api/cards-api';
import CardsBoardItem from './components/CardsBoardItem';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import LoginPage from '../login/Login';
import ConfirmUserPage from '../confirmUser/ConfirmUser';
import HomePage from '../home/Home';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Outlet } from "react-router";
import CardsBoard from './CardsBoard';
import CardsAdd from './CardsAdd';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CardsManagement from './CardsManagement';
import Container from '@mui/material/Container';

const CardsLayout = () => {
    return (
        <>
            <Container maxWidth="sm">
                <h1>Cards</h1>
                <Outlet />
            </Container>

            <BottomNavigation
                showLabels
                sx={{ position: 'fixed', bottom: 0, width: 1.0 }}
            >
                <BottomNavigationAction component={Link} to="/cards/add" label="Add" icon={<AddIcon />} />
                <BottomNavigationAction component={Link} to="/cards/manage" label="List" icon={<FormatListBulletedIcon />} />
            </BottomNavigation>
        </>
    );


};

export default CardsLayout;